import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import NavbarBrand from "./components/navbarBrand";
import MainCarousel from "./components/mainCarousel";
import AboutSection from "./components/aboutSection";
import Portfolio from "./components/portfolioSection";
import ContactSection from "./components/contactSection";
import Footer from "./components/footer";
import "bootstrap/dist/css/bootstrap.min.css";
import firebase from "./components/firebase.js";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams
} from "react-router-dom";
import Home from "./components/Home";

ReactDOM.render(<App />, document.getElementById("root"));

/*ReactDOM.render(<NavbarBrand />, document.getElementById("Navbar"));
ReactDOM.render(<MainCarousel />, document.getElementById("Home"));
ReactDOM.render(<Portfolio />, document.getElementById("Portfolio"));
ReactDOM.render(<AboutSection />, document.getElementById("About"));
ReactDOM.render(<ContactSection />, document.getElementById("Contact"));
ReactDOM.render(<Footer />, document.getElementById("Footer"));
*/
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
